import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getAuthHeaders } from "../../utils/apiHeaders";

var API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export var checkoutOrder = createAsyncThunk(
  "orders/checkoutOrder",
  async function (language, thunkApi) {
    try {
      var response = await fetch(API_BASE_URL + "/orders/checkout", {
        method: "POST",
        signal: thunkApi.signal,
        headers: getAuthHeaders(language),
      });

      var responseData = await response.json();

      if (!response.ok) {
        return thunkApi.rejectWithValue({
          message: responseData.message || "Unable to start checkout",
        });
      }

      return responseData.data;
    } catch (error) {
      return thunkApi.rejectWithValue({
        message: error.message || "Unable to connect to the server",
      });
    }
  }
);

export var fetchOrders = createAsyncThunk(
  "orders/fetchOrders",
  async function (payload, thunkApi) {
    try {
      var language = payload && payload.language;
      var page = (payload && payload.page) || 1;

      var response = await fetch(
        API_BASE_URL + "/orders?page=" + page,
        {
          method: "GET",
          signal: thunkApi.signal,
          headers: getAuthHeaders(language),
        }
      );

      var responseData = await response.json();

      if (!response.ok) {
        return thunkApi.rejectWithValue({
          message: responseData.message || "Unable to retrieve orders",
        });
      }

      return {
        orders: Array.isArray(responseData.data) ? responseData.data : [],
        pagination: responseData.pagination || null,
      };
    } catch (error) {
      return thunkApi.rejectWithValue({
        message: error.message || "Unable to connect to the server",
      });
    }
  }
);

export var fetchOrderById = createAsyncThunk(
  "orders/fetchOrderById",
  async function (payload, thunkApi) {
    try {
      var orderId = payload.orderId;
      var language = payload.language;

      var response = await fetch(
        API_BASE_URL + "/orders/" + encodeURIComponent(orderId),
        {
          method: "GET",
          signal: thunkApi.signal,
          headers: getAuthHeaders(language),
        }
      );

      var responseData = await response.json();

      if (!response.ok) {
        return thunkApi.rejectWithValue({
          message: responseData.message || "Unable to retrieve order",
        });
      }

      return responseData.data;
    } catch (error) {
      return thunkApi.rejectWithValue({
        message: error.message || "Unable to connect to the server",
      });
    }
  }
);

var initialState = {
  checkoutLoading: false,
  checkoutError: "",

  orders: [],
  pagination: null,
  ordersLoading: false,
  ordersError: "",

  selectedOrder: null,
  orderLoading: false,
  orderError: "",
};

var ordersSlice = createSlice({
  name: "orders",
  initialState: initialState,
  reducers: {},
  extraReducers: function (builder) {
    builder
      .addCase(checkoutOrder.pending, function (state) {
        state.checkoutLoading = true;
        state.checkoutError = "";
      })
      .addCase(checkoutOrder.fulfilled, function (state) {
        state.checkoutLoading = false;
      })
      .addCase(checkoutOrder.rejected, function (state, action) {
        state.checkoutLoading = false;
        state.checkoutError =
          (action.payload && action.payload.message) || "Unable to start checkout";
      })

      .addCase(fetchOrders.pending, function (state) {
        state.ordersLoading = true;
        state.ordersError = "";
      })
      .addCase(fetchOrders.fulfilled, function (state, action) {
        state.ordersLoading = false;
        state.orders = action.payload.orders;
        state.pagination = action.payload.pagination;
      })
      .addCase(fetchOrders.rejected, function (state, action) {
        state.ordersLoading = false;
        state.ordersError =
          (action.payload && action.payload.message) || "Unable to retrieve orders";
      })

      .addCase(fetchOrderById.pending, function (state) {
        state.orderLoading = true;
        state.orderError = "";
        state.selectedOrder = null;
      })
      .addCase(fetchOrderById.fulfilled, function (state, action) {
        state.orderLoading = false;
        state.selectedOrder = action.payload;
      })
      .addCase(fetchOrderById.rejected, function (state, action) {
        state.orderLoading = false;
        state.orderError =
          (action.payload && action.payload.message) || "Unable to retrieve order";
      });
  },
});

export default ordersSlice.reducer;
